/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
import Tabs from "components/lib/Shared/Tabs";
import { useEffect, useState } from "react";
import AnnualReturns from "./AnnualReturns";
import FinancialStatements from "./FinancialStatements";
import AnnualGeneralMeeting from "./AnnualGeneralMeeting";
import { useSelector } from "react-redux";

const Summary = ({ handleGoForward, handleGoBack, selectedChangeTypes }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const tabs = [
    {
      id: "annualReturns",
      label: "Annual Return",
    },
    {
      id: "financialStatements",
      label: "Financial Statements",
    },
    {
      id: "annualGeneralMeeting",
      label: "General Meeting",
      disabled: true,
    },
  ].filter((tab) => selectedChangeTypes.includes(tab.id));

  const [selectedTab, setSelectedTab] = useState(tabs[0].id);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex].id);
  }, [selectedTabIndex, tabs]);

  return (
    <div>
      <Tabs
        tabs={tabs}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
      />

      {selectedTab === "annualReturns" && (
        <AnnualReturns
          handleGoForward={handleGoForward}
          handleGoBack={handleGoBack}
        />
      )}
      {selectedTab === "financialStatements" && (
        <FinancialStatements
          handleGoForward={handleGoForward}
          handleGoBack={handleGoBack}
        />
      )}
      {selectedTab === "annualGeneralMeeting" && <AnnualGeneralMeeting />}
    </div>
  );
};

export default Summary;
